import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Public
export const createInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const getEvents = () => api.get("/events").then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);

// Admin (JWT bearer token)
const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);
export const getInquiries = (t) => api.get("/inquiries", authHeader(t)).then((r) => r.data);
export const updateInquiry = (id, body, t) =>
  api.patch(`/inquiries/${id}`, body, authHeader(t)).then((r) => r.data);
export const deleteInquiry = (id, t) => api.delete(`/inquiries/${id}`, authHeader(t)).then((r) => r.data);
export const getAllEvents = (t) =>
  api.get("/events?published_only=false", authHeader(t)).then((r) => r.data);
export const createEvent = (data, t) => api.post("/events", data, authHeader(t)).then((r) => r.data);
export const updateEvent = (id, data, t) => api.put(`/events/${id}`, data, authHeader(t)).then((r) => r.data);
export const deleteEvent = (id, t) => api.delete(`/events/${id}`, authHeader(t)).then((r) => r.data);
export const getSummary = (t) => api.get("/admin/summary", authHeader(t)).then((r) => r.data);
export const updateSettings = (data, t) => api.put("/settings", data, authHeader(t)).then((r) => r.data);
export const changePassword = (current_password, new_password, t) =>
  api.post("/admin/change-password", { current_password, new_password }, authHeader(t)).then((r) => r.data);
